import { ActionReducerMapBuilder, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit'
import { AxiosResponse } from 'axios'
import { EpaApi } from '../../../../services'
import { IAggregateWellWaterSystemsMetrics, ICountyWellWaterSystemResult, IRegionWellWaterSystemResult, RequestConfig } from '../../../../types';
import { WellWaterSystemsAggregatesInitialState, ZoomLevel } from '../wellWaterSystemAggregates.slice';

export const fetchAggregatedWellWaterSystemsAsync = createAsyncThunk(
  'systems/fetchWellAggregates',
  async (
    { zoomLevel, stateCode, stateName, options }: { zoomLevel: string, stateCode?: string, stateName?: string, options?: RequestConfig },
    { rejectWithValue }
  ) => {
    try {
      const response = await EpaApi.fetchAggregatedWellWaterSystems(zoomLevel, stateCode, stateName, options);
      return (response as AxiosResponse<any>).data;
    } catch (error: any) {
      console.error(error);
      return rejectWithValue(error);
    }
  }
);

export const fetchAggregatedWellWaterSystemsAsyncBuilder = (
  builder: ActionReducerMapBuilder<WellWaterSystemsAggregatesInitialState>
) => {
  builder.addCase(fetchAggregatedWellWaterSystemsAsync.pending, (state) => {
    state.loading = true;
    state.success = false;
    state.error = '';
  });

  builder.addCase(
    fetchAggregatedWellWaterSystemsAsync.fulfilled,
    (state, action: PayloadAction<IAggregateWellWaterSystemsMetrics>) => {
      state.loading = false;
      state.success = true;
  
      if (action.payload.zoomLevel === ZoomLevel.REGION) {
        state.regionsHousingUnits = action.payload.result as IRegionWellWaterSystemResult[];
      } else if (action.payload.zoomLevel === ZoomLevel.COUNTY) {
        state.countiesHousingUnits = action.payload.result as ICountyWellWaterSystemResult[];
      }
    }
  );
  

  builder.addCase(
    fetchAggregatedWellWaterSystemsAsync.rejected,
    (state, action: PayloadAction<any>) => {
      state.loading = false;
      state.success = false;
      state.error = action.payload;
    }
  );
};
